export const page = {
  seo: {
    title: 'Website voor jouw restaurant of horecazaak | Bistroo',
    description: 'Een gepersonaliseerde website voor jouw restaurant of horecazaak, volledig aanpasbaar naar jouw wensen. Binnen no-time online, 30 dagen gratis. Inclusief SEO-optimalisatie en eigen domeinnaam.',
  },
  hero: {
    title: {
      pt1: 'Een',
      pt2: 'website',
      pt3: 'volledig afgestemd op jouw restaurant',
    },
    description:
      'De website van Bistroo biedt de tools om een volledige conversie-verhogende landingspagina te creëren die de bestelervaring van je klanten van begin tot eind verbetert.',
    button: 'Maak je website',
  },
  paragraphs: {
    paragraph_1: {
      title: 'Eenvoudig te bouwen, moeiteloos te onderhouden',
      text: 'De website wordt gegenereerd op basis van de informatie van je restaurant en is eenvoudig aan te passen om perfect bij de stijl en branding van jouw restaurant aan te sluiten.',
      cta: 'Verken de Bistroo pakketten',
    },
    paragraph_2: {
      title: 'Automatisch geupdate',
      text: 'Alle wijzigingen die je aanbrengt in de Bistroo Manager worden direct doorgevoerd op je website, zodat je geen informatie handmatig hoeft bij te werken op meerdere editors of locaties.',
      cta: '',
    },
    paragraph_3: {
      title: 'Bied een uitstekende klantervaring',
      text: 'Van de eerste klik tot de betaling, jouw klanten genieten van een goed ontworpen bestelervaring die bijdraagt aan elke stap. Wat zowel de klantervaring als de reputatie van jouw restaurant versterkt.',
      cta: 'Verken de Bistroo pakketten',
    },
    paragraph_4: {
      title: 'Geoptimaliseerd voor online gebruik en e-commerce',
      text: "Onze landingspagina's zijn ontworpen en gebouwd voor optimale SEO. Bereik de top van de organische zoekresultaten in jouw regio of geef je website een boost met kostenefficiënte advertenties.",
      cta: '',
    },
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Zet je bestsellers in de spotlight.',
        text: 'Je menu-aanpassingen en best verkochte items zijn naadloos verbonden met je website, geen extra werk nodig. ',
        button: '',
        img_alt: '',
      },
      card_2: {
        title: 'Integraties.',
        text: 'Koppel je favoriete POS-systeem of externe tools.',
        button: '',
        img_alt: '',
      },
      card_3: {
        title: 'Presenteer en deel belangrijke informatie.',
        text: 'Communiceer belangrijke informatie duidelijk via je website door de instellingen in de Manager-app te wijzigen. ',
        button: '',
        img_alt: '',
      },
      card_4: {
        title: 'Contactformulieren.',
        text: 'Laat verzoeken toe via het geïntegreerde contactformulier.',
        button: '',
        img_alt: '',
      },
      card_5: {
        title: 'Geoptimaliseerd voor alle kanalen.',
        text: 'Alle websites zijn geoptimaliseerd voor Google Search én geschikt voor weergave op alle soorten apparaten.',
        button: '',
        img_alt: '',
      },
    },
  },
  testimonial: {
    text: '"Bistroo bespaart ons dagelijks veel tijd en vermindert de frustratie bij klanten aanzienelijk."',
    cta: 'Lees volledig verhaal',
    name: 'Two-B by Mondie',
    job_title: 'Lunchroom',
  },
  faq: {
    title_pt1: 'Alles over de',
    title_pt2: 'Bistroo Website',
    items: [
      { q: 'Wat is de Bistroo restaurantwebsite?', a: 'De Bistroo restaurantwebsite is een gepersonaliseerde landingspagina voor jouw horecazaak. Gasten vinden hier je menu, openingstijden, locatie en een directe bestelknop, allemaal in jouw huisstijl.' },
      { q: 'Hoe maak ik mijn Bistroo-website aan?', a: 'De website wordt automatisch gegenereerd op basis van de informatie in je Bistroo-account. Na je aanmelding kies je een template, voeg je je logo en kleuren toe en is je site klaar om te publiceren.' },
      { q: 'Kan ik een eigen domeinnaam gebruiken?', a: 'Ja. Je koppelt je eigen domeinnaam aan de Bistroo-website zodat klanten je vinden via jouw eigen adres, zoals www.jouwrestaurant.nl.' },
      { q: 'Is mijn website geoptimaliseerd voor Google?', a: 'Ja. Alle Bistroo-websites zijn technisch geoptimaliseerd voor zoekmachines. Je scoort beter in lokale zoekresultaten en via Google Maps, zodat nieuwe klanten je makkelijker vinden.' },
      { q: 'Worden menuwijzigingen automatisch bijgewerkt op de website?', a: 'Ja. Wijzigingen die je maakt in de Bistroo Manager worden direct doorgevoerd op je website. Je hoeft nooit op meerdere plekken tegelijk aan te passen.' },
      { q: 'Kan ik de stijl en uitstraling van mijn website aanpassen?', a: 'Ja. Je past de kleuren, het lettertype, de headerafbeelding en de indeling aan via de Manager. Zo past de website perfect bij de sfeer van jouw restaurant.' },
      { q: 'Is de website ook goed te bekijken op mobiel?', a: 'Ja. Alle Bistroo-websites zijn volledig responsive en geoptimaliseerd voor smartphones en tablets. De meeste bezoekers bekijken restaurants op hun telefoon, dus dat klopt helemaal.' },
      { q: 'Kan ik een contactformulier toevoegen aan mijn website?', a: 'Ja. Via de websiteinstellingen in de Manager activeer je een contactformulier waarop gasten vragen, reserveringsverzoeken of catering-aanvragen kunnen indienen.' },
      { q: 'Hoe promoot ik acties en aanbiedingen op mijn website?', a: 'Via de Manager voeg je banners, promotieteksten en kortingscodes toe die direct zichtbaar zijn op je website. Zo communiceer je altijd de laatste aanbiedingen aan jouw bezoekers.' },
      { q: 'Wat kost de Bistroo restaurantwebsite?', a: 'De basispagina is inbegrepen bij elk Bistroo-pakket. Voor een volledig white-label website met eigen domein en uitgebreide aanpassingsmogelijkheden is een betaald pakket beschikbaar.' },
    ],
  },
}
